import { useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { IconFilter } from '@medifind/icons';
import { usePublicationCriteriaFilter } from '@medifind/zustand';
import { FilterModal } from '../filters/FilterModal';
import { PublicationResultFilterList } from '../filters/PublicationResultFilterList';
import styles from './FilterGroups.module.scss';

const PublicationFiltersGroup = ({ classes, totalResults, criteriaKeywords }) => {
  const publicationCriteria = usePublicationCriteriaFilter();
  const activeFiltersCount = useMemo(() => {
    const selectedValues = [publicationCriteria?.selected?.length > 0];
    // removes false values
    return selectedValues.filter(Boolean).length;
  }, [publicationCriteria?.selected]);

  return (
    <>
      <div className={classNames(classes.filters, styles['publication-filters-section'])}>
        <div>Found {totalResults || 0} publications</div>

        <div className={classNames(classes.moreFiltersButton, styles['more-filters-button'])}>
          <FilterModal
            title="Filter your publication search"
            filterButton
            resultsText={`${totalResults} publications found`}
            filterButtonLabel={
              <>
                Filter <span style={{ fontSize: '12px' }}>({activeFiltersCount})</span>
              </>
            }
            iconBefore={<IconFilter color="#242a45" />}
            clearFilters={() => {
              publicationCriteria?.reset();
            }}
          >
            <PublicationResultFilterList criteriaKeywords={criteriaKeywords} />
          </FilterModal>
        </div>
      </div>
    </>
  );
};

PublicationFiltersGroup.propTypes = {
  classes: PropTypes.shape({
    filters: PropTypes.string,
    label: PropTypes.string,
    filter: PropTypes.string,
    filterWrapper: PropTypes.string,
  }),
};
PublicationFiltersGroup.defaultProps = {
  classes: {},
};

export { PublicationFiltersGroup as default, PublicationFiltersGroup };
